$(() => {
    const search = $('.search');
    const searchbtn = $('.searchbtn');
    $('a.searchbtn').on('click', (e) => {
        if (search.hasClass('open')) {
            search.removeClass('open');
            searchbtn.removeClass('open');
        } else {
            search.addClass('open');
            searchbtn.addClass('open');
        }
        e.preventDefault();
    });
});
